export function LlmChatAssistantStepDivider() {
  return <div className='h-px w-full bg-border/40' aria-hidden />
}
